module.exports = __webpack_public_path__ + "img/b5.dc697ce4.png";